


























































































































import { Component, Model, Prop, Watch, Vue } from "vue-property-decorator";

type SelectOption = Record<string, string | number>;

const getText = (o: SelectOption, key: string) => (o[key] ?? "").toString();

@Component
export default class DfiSelectMultiple extends Vue {
  @Model("update:modelValue") value!: SelectOption[];
  @Prop({ default: "" }) label!: string;
  @Prop() placeholder!: string;
  @Prop() valueFormatter!: (n: number) => string;
  @Prop() options!: SelectOption[];
  @Prop({ default: "name" }) itemText!: string;
  @Prop({ default: "id" }) itemValue!: string;
  @Prop({ default: true }) offsetY!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop() noOptionsText!: string;
  @Prop() noOptionsFoundText!: string;

  menuVisible: boolean = false;
  nameFilter: string = "";

  get filteredOptions(): SelectOption[] {
    const filter = this.nameFilter.toLowerCase();

    return this.options.filter((o) => getText(o, this.itemText).toLowerCase().includes(filter));
  }

  get isAllOptionsSelected(): boolean {
    return this.value.length === this.filteredOptions.length && this.value.length > 0;
  }

  get isSomeOptionsSelected(): boolean {
    return this.value.length > 0 && this.value.length < this.filteredOptions.length;
  }

  @Watch("menuVisible")
  onMenuStateChange() {
    if (this.menuVisible) {
      this.$emit("open");
    } {
      this.$emit("close");
    }
  }

  toggle() {
    if (this.value.length === this.filteredOptions.length) {
      this.$emit("update:modelValue", []);
    } else {
      const newSelection = [...this.value];
      this.filteredOptions.forEach(o => {
        if (!newSelection.find(so => so[this.itemValue] === o[this.itemValue])) {
          newSelection.push(o);
        }
      });

      this.$emit("update:modelValue", newSelection);
    }
  }

  onCheckboxChange(option: SelectOption) {
    const isSelected = this.value.includes(option);

    if (isSelected) {
      this.$emit(
        "update:modelValue",
        this.value.filter(v => v[this.itemValue] !== option[this.itemValue])
      );
    } else {
      this.$emit("update:modelValue", [...this.value, option]);
    }
  }

  onActivatorClick(on: Record<string, (e: Event) => void>, event: Event) {
    if (this.disabled || this.loading) return;

    on.click(event);
  }
}
